import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import { getFormatDateTimeWithRegionalSettings } from 'common/helpers/dateUtils';
import { getFileIconClass } from '../../../helpers/helper_functions';
import { DocumentDeleteButton } from './DocumentDeleteButton';
import Badge from '../../v2/Badge';
import { getSignedUrl } from '../../../utils/DocumentsAPIUtils';
import { showToast } from '../../../stores/ToastStore';

export const DOCUMENT_STATUSES = {
  PENDING: 'PENDING',
  UPLOADED: 'UPLOADED',
  UPLOAD_FAILED: 'UPLOAD_FAILED',
};

export const DOCUMENT_STATUSES_TITLE_MAP = {
  [DOCUMENT_STATUSES.PENDING]: 'Pending',
  [DOCUMENT_STATUSES.UPLOADED]: 'Uploaded',
  [DOCUMENT_STATUSES.UPLOAD_FAILED]: 'Upload failed',
};

export const Document = ({
  isOrder,
  document,
  deleteDisabled,
  onDeleteConfirm,
  onDeleteDecline,
  isSent,
}) => {
  const [url, setUrl] = useState(null);
  const { t } = useTranslation();
  const extension = document.key.split('.').pop().toUpperCase();
  const documentName = t(sluggify(document.name));

  useEffect(() => {
    setUrl(null);
  }, [document.key]);

  const openDocument = async () => {
    let signedUrl = url;

    if (!url) {
      const { data, errors } = await getSignedUrl(document.key);

      if (errors) {
        showToast(
          t('GET_SIGNED_URL_ERROR'),
          t('GET_SIGNED_URL_FAILED_WITH_ERROR', { error: errors[0].message }),
          'error',
        );

        return;
      }

      signedUrl = data?.getSignedUrl.signedUrl;

      setUrl(signedUrl);
    }

    window.open(signedUrl, '_blank');
  };

  return (
    (<tr data-testid="tr-5721e957">
      <td data-testid="td-f85c0370">
        <div data-testid="div-1843e570" className="flex items-center space-x-2">
          <i data-testid="i-ff471a3c" className={getFileIconClass(extension)} />
          <a data-testid="a-f71a9fae" className="relative" onClick={openDocument}>
            <span data-testid="span-3c76e195">{documentName}</span>
          </a>
        </div>
      </td>
      <td data-testid="td-150be71d">
        <span data-testid="span-37c2fee7">
          {document.createdAt &&
            getFormatDateTimeWithRegionalSettings(document.createdAt)}
        </span>
      </td>
      <td data-testid="td-e00aae74">
        <div data-testid="div-e44c2286" className="flex items-center space-x-1">
          {isSent && <Badge dataTestId="Badge-3e5eecae" color="green">{t('EMAIL_SENT')}</Badge>}
          {document.signatory && !isSent && (
            <Badge dataTestId="Badge-47376021" color="green">{document.signatory}</Badge>
          )}
          {/* {deliveryOrderSent && this.renderDeliveryOrderSent(auditEvent)} */}
        </div>
      </td>
      <td data-testid="td-7d40b57e">
        {document.status && (
          <small data-testid="small-cd1270ab">
            <i data-testid="i-a2e4584d">
              {t(
                sluggify(
                  DOCUMENT_STATUSES_TITLE_MAP[document.status] || 'Unknown',
                ),
              )}
            </i>
          </small>
        )}
      </td>
      <td data-testid="td-661bca7f">
        <div data-testid="div-791e6132" className="flex items-center space-x-1">
          {!deleteDisabled && (
            <DocumentDeleteButton
              isOrder={isOrder}
              document={document}
              onConfirm={onDeleteConfirm}
              onDecline={onDeleteDecline}
            />
          )}
        </div>
      </td>
    </tr>)
  );
};
